var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockCloseFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9997 5.75002C20.9663 5.75002 19.0163 6.55776 17.5785 7.99553C16.1407 9.43331 15.333 11.3834 15.333 13.4167V19.1667H30.6663V13.4167C30.6663 11.3834 29.8586 9.43331 28.4208 7.99553C26.983 6.55776 25.033 5.75002 22.9997 5.75002ZM34.4997 19.1667V13.4167C34.4997 10.3667 33.2881 7.44163 31.1314 5.28496C28.9747 3.12829 26.0497 1.91669 22.9997 1.91669C19.9497 1.91669 17.0246 3.12829 14.8679 5.28496C12.7113 7.44163 11.4997 10.3667 11.4997 13.4167V19.1667H9.58301C6.40737 19.1667 3.83301 21.741 3.83301 24.9167V38.3334C3.83301 41.509 6.40737 44.0834 9.58301 44.0834H36.4163C39.592 44.0834 42.1663 41.509 42.1663 38.3334V24.9167C42.1663 21.741 39.592 19.1667 36.4163 19.1667H34.4997Z",
    fill: "#08172B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCloseFilled);
export default __webpack_public_path__ + "static/media/lockCloseFilled.d8781e7d0ba6452bce07c5c708007845.svg";
export { ForwardRef as ReactComponent };